import axios from 'axios';
import authConfig from '@/../auth_config.json';

let str = axios.create({
    baseURL: authConfig.storeDomain,
})
str.interceptors.request.use(function (config) {
    let token = localStorage.getItem("access_token");
    let language = localStorage.getItem("language");
    if (!language) language = "vi-VN";
    config.headers["Accept-Language"] = language;
    if (token) {
        config.headers["Authorization"] = "Bearer " + token;
    }
    return config
});
str.interceptors.response.use(function (config) {
        let token = localStorage.getItem("access_token");
        let language = localStorage.getItem("language");
        if (!language) language = "vi-VN";
        config.headers["Accept-Language"] = language;
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    function (error) {

        if (error && error.response.status === 401) {
            localStorage.clear();
            return location.reload();
        }

        return Promise.reject(error)
    })

export default str;
